// Firestore stores XP as a number. Legacy numeric strings are accepted during
// migration, but null/empty/boolean values are not valid numeric baselines:
// Number(null) and Number("") both equal zero and would otherwise make a
// signed mutation silently replace an unknown account total with a zero base.
export const getServerExperience = (value: string|number|boolean|null|undefined) => {
  if (value == null || value === "" || typeof value === "boolean") return null;
  const experience = Number(value);
  return Number.isFinite(experience) ? Math.max(0, experience) : null;
};

